import React from "react";
import Card from "./Card";

const ActionCard = ({
  count = 0, items = [], small = false, subText,
}) => (
  <Card className={`action-card ${small ? "small" : ""}`}>
    <div className="action-count">{count}</div>
    <span className="item-subText">{subText}</span>
    <ul className="action-list">
      {items.map((it, idx) => (
        <li className={`action-item ${it.type || ""}`}>
          <span className="item-bullet">{it.number}</span>
          <span className="item-text">
            {it.text}
            <div className="item-arrow"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.98096 9.95215L7.96169 5.97142L3.98096 1.99069" stroke="#B4BAC2" stroke-width="1.11958" stroke-linecap="round" stroke-linejoin="round" />
            </svg>  </div>
          </span>
          <span className="item-link-text">
            {it.linkText}
          </span>

          {/* {it.link && (
            <a className="item-link" href={it.link}>
              {it.linkText || "Review"}
            </a>
          )} */}
        </li>
      ))}
    </ul>
  </Card>
);

export default ActionCard;
